import {
  GelButton,
  GelIcon,
  GelRow,
  GelCol,
  GelForm,
  GelFormField,
} from "@tal-gel/components";
import { getGelTokens } from "@tal-gel/theming";
import { useEffect, useState } from "react";
import {
  AdobeClickType,
  API,
  CookieConfig,
  DIGITAL_FORM_TYPE,
  FILE_UPLOAD_STATUS,
  TFN_DETAILS_REQUIREMENTS,
} from "../../../constants/constants";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { CONFIGURE_MFA } from "../../../graphql/queries/graphql-mutations";
import { useNavigate } from "react-router-dom";
import { DocumentModel } from "../../../common/models/document.model";
import DocumentDownload from "../documentDownload/documentDownload";
import SESSION_STORAGE_KEY from "../../../constants/storage.constant";
import { AdobeAnalytics } from "../../../common/analytics/adobe-analytics";

interface OtherRequirementProps {
  requirement: any;
  contentFullData: any;
  memberNumber: string;
  requirementData?: DocumentModel;
}

// TODO: refactor this component
const OtherRequirement = (props: OtherRequirementProps) => {
  const { global: { sizeBaseX4, sizeBaseX2, sizeBaseX16, sizeBaseX6 } } = getGelTokens()

  const navigate = useNavigate();
  const [{ aid, rid, ssoid, tpid }, setSsoCookies] = useCookies([
    "aid",
    "rid",
    "ssoid",
    "tpid",
    "sid",
  ]);
  var [fileList, setFileList] = useState<any>([]);

  let files = fileList ? [...fileList] : [];

  useEffect(() => {
    if (props.requirement?.associatedDocuments) {
      if (props.requirement.associatedDocuments.length > 0) {
        fileList = [];
        setFileList([
          ...fileList,
          ...props.requirement.associatedDocuments.map(toFile),
        ]);
      }
    }
  }, []);

  const toFile = (file: any) => {
    return {
      id: file.fileId,
      status: FILE_UPLOAD_STATUS.SUCCESS,
      name: file.displayName,
      sharePointDocumentIdentifier: file.sharePointDocumentIdentifier,
      displayName: file.displayName,
    };
  };

  const onSubmit = () => {
    AdobeAnalytics.PushClickEvent(tpid, buttonText, AdobeClickType.Button);
  
    const user           = jwtDecode(aid);
    const isTfn          = TFN_DETAILS_REQUIREMENTS.includes(props.requirement.description);
    const micrositeBase  = isTfn ? API.TFN_REDIRECT : API.EFT_REDIRECT;
  
    // helper: base-64-encode current page (strips query if ?source already present)
    const origin = (() => {
      const url = window.location.href;
      return btoa(url.includes("?source=") ? url.split("?", 1)[0] : url);
    })();
  
    // helper: shared microsite redirect
    const redirectToMicrosite = (route: string) => {
      const qs = new URLSearchParams({
        username      : user.sub ? String(user.sub) : "",
        claimId       : String(props.requirement.claimId),
        requirementId : String(props.requirement.id),
        memberNumber  : String(props.memberNumber),
        origin        : String(origin),            // still base-64 encoded
      }).toString();
    
      redirect(`${micrositeBase}/#/${route}?${qs}`);
    };
  
    // always reset history and set the SID cookie
    window.history.pushState({}, "", window.location.href);
    setSsoCookies(
      "sid",
      window.sessionStorage.getItem(SESSION_STORAGE_KEY.SESSIONID_TOKEN),
      {
        domain   : CookieConfig.DOMAIN,
        path     : CookieConfig.PATH,
        secure   : true,
        sameSite : "lax",
        expires  : new Date(Date.now() + 86_400_000), // +24 h
      }
    );
  
    // ── Automation shortcut ────────────────────────────────────────────────────────
    if (props.memberNumber.includes("AutomationCA")) {
      return redirectToMicrosite("automation-login");
    }
  
    // ── Standard flow ─────────────────────────────────────────────────────────────
    const requestData = {
      userName     : user.sub,
      memberNumber : props.memberNumber,
      source       : isTfn ? DIGITAL_FORM_TYPE.TFN : DIGITAL_FORM_TYPE.EFT,
    };
  
    axios.post(
      API.BASEURL,
      {
        query     : CONFIGURE_MFA,
        variables : { mfaConfigRequest: requestData },
      },
      {
        headers: {
          "x-aid": aid,
          "x-rid": rid,
          ssoid,
          tpid,
          sid: window.sessionStorage.getItem(SESSION_STORAGE_KEY.SESSIONID_TOKEN),
        },
      }
    )
    .then(res => {
      if (res.data.data.configureUserMfa.isSuccess) {
        redirectToMicrosite("verify-passcode");
      } else {
        console.error("failed to send MFA sms");
        navigate("/error");
      }
    });
  };
  
  const buttonText = TFN_DETAILS_REQUIREMENTS.includes(
    props.requirement.description
  )
    ? props.contentFullData?.formButtons?.TfnButtontext
    : props.contentFullData?.formButtons?.EftButtonText;
  const redirect = (redirectUrl) => {
    window.location.replace(redirectUrl);
  };
  return (
    <GelForm labelAtTop={true} onSubmit={onSubmit}>
      <GelFormField width="auto">
        <GelButton
          style={{
            width: "100%",
            textTransform: "unset",
          }}
          name=""
          primary
          large
          submit
        >
          {buttonText}
        </GelButton>

        {files.map((file, index) => (
          <GelRow
            style={{
              paddingLeft:
                files?.length === 1
                  ? sizeBaseX4
                  : sizeBaseX16,
              paddingBottom: sizeBaseX2,
              paddingTop: sizeBaseX2,
            }}
            key={Math.random()}
          >
            <GelCol
              style={{
                maxWidth: "3%",
                textAlign: "left",
              }}
            >
              <GelRow style={{ paddingTop: sizeBaseX2 }}>
                <GelIcon
                  name="Attachment"
                  width={sizeBaseX6}
                  height={sizeBaseX6}
                />
              </GelRow>
            </GelCol>

            <GelCol>
              <GelRow>
                <GelCol
                  style={{
                    flex: 9,
                    paddingLeft: 0,
                    paddingTop: "10px",
                  }}
                >
                  <DocumentDownload
                    documentIdentifier={file.sharePointDocumentIdentifier}
                    displayName={file.name}
                  ></DocumentDownload>
                </GelCol>
              </GelRow>
            </GelCol>
          </GelRow>
        ))}
      </GelFormField>
    </GelForm>
  );
};

export default OtherRequirement;
